/// <amd-module name="Agile/SplitView/Components/SidePane" />
import * as React from "react";
import { css, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

export interface ISidePaneProps {
    title: string;
    description?: string;
    onDismiss: () => void;
    className?: string;
}

export class SidePane extends VssComponent {
    constructor(props: ISidePaneProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <div className="side-pane-container">
                <div className={css("side-pane-header", this.props.className)}>
                    <div className="side-pane-header-title-row">
                        <h3 className="side-pane-header-title">{this.props.title}</h3>
                        <Button
                            className="side-pane-header-close-button"
                            iconProps={{ iconName: "Cancel" }}
                            subtle={true}
                            onClick={this.props.onDismiss}
                        />
                    </div>
                    {this.props.description && <div className="side-pane-header-description">{this.props.description}</div>}
                </div>
                <div className="side-pane-content-scroll-container">{this.props.children}</div>
            </div>
        );
    }
}
